import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IFileItem, IFolderList } from '../multipart.interface';
import { AwsS3UploadService } from '../aws-s3-upload.service';

@Component({
  selector: 'mango-folder-upload',
  templateUrl: './folder-upload.component.html',
  styleUrls: ['./folder-upload.component.scss'],
})
export class FolderUploadComponent implements OnInit {
  modalRef!: BsModalRef;

  @Input() data!: IFolderList;
  @Input() listView: string = 'grid';
  @Input() showMoreLimit!: number; // show more option (infinite scroll)

  token: string = Math.random().toString(36).substr(2) + new Date().getTime();
  progress: number = 0;
  isUploading: boolean = false;
  selectedListView: string = 'grid';

  page: number = 0;
  listSingleFilesPaginateUI: IFileItem[] = [];
  totalFiles: number = 0;

  progressPartsPercent = [];

  constructor(
    private awsS3UploadService: AwsS3UploadService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.page = 0;
    this.progressPartsPercent = [];
    // this.listSingleFilesPaginateUI = this.showMoreLimit ? this.paginate(this.validFiles(), this.showMoreLimit) : this.data.files;
    this.listSingleFilesPaginateUI = this.data.files;
    this.totalFiles = this.data.files.filter(
      (item) => item.type !== 'mng-compressed'
    ).length;
  }

  openModalDetails(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'uploader-detail-modal' })
    );
  }

  onSelectedHandle(event: any) {
    this.selectedListView = event;
  }

  validFiles() {
    return this.data.files.filter(
      (item) => item.status === 1 && item.type !== 'mng-compressed'
    );
  }

  /**
   * Paginate show more option.
   *
   * @param array
   * @param pageSize
   * @param pageNumber
   */
  paginate(array: any, pageSize: any, pageNumber?: any) {
    this.page++;
    pageNumber = this.page;
    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
  }

  /**
   * Show more.
   */
  btnShowMore() {
    this.listSingleFilesPaginateUI = [
      ...this.listSingleFilesPaginateUI,
      ...this.paginate(this.validFiles(), this.showMoreLimit),
    ];
  }
}
